// Sentry init for admin — mirror of apps/user/src/sentry.ts. Same DSN
// (set via VITE_SENTRY_DSN on CF Pages); worker errors land in the
// same project as learner errors, distinguished by the `app` tag.

import * as Sentry from "@sentry/react";
import { env } from "./env";

let initialized = false;

export function initSentry(): void {
  if (initialized) return;
  if (!env.sentryDsn) return;
  Sentry.init({
    dsn: env.sentryDsn,
    release: env.release,
    environment: env.useEmulators ? "emulator" : "production",
    tracesSampleRate: 0.1,
    initialScope: { tags: { app: "admin" } },
    integrations: [],
    beforeBreadcrumb(crumb) {
      if (crumb.data && typeof crumb.data === "object") {
        const data = crumb.data as Record<string, unknown>;
        if (typeof data.url === "string") {
          try {
            const u = new URL(data.url);
            u.search = "";
            data.url = u.toString();
          } catch {
            /* ignore */
          }
        }
      }
      return crumb;
    },
  });
  initialized = true;
}

export function reportError(
  error: unknown,
  context?: Record<string, unknown>,
): void {
  // eslint-disable-next-line no-console
  console.error("[reportError]", error, context);
  if (!initialized) return;
  Sentry.captureException(error, context ? { extra: context } : undefined);
}

/** Tag events with the signed-in worker's email. */
export function setSentryUser(email: string | null): void {
  if (!initialized) return;
  Sentry.setUser(email ? { email } : null);
}
